export default function CadastroOrdemCompra(){
    return "Cadastro Ordem Compra"
}